module.exports = __webpack_public_path__ + "static/img/zqfd@2x.91cb74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/zqfd@2x.png
// module id = coDR
// module chunks = 3 4